var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/joy';
import { useImpersonation } from '../../../contexts/ImpersonationContext';
export var ImpersonationBanner = function () {
    var _a = useImpersonation(), isImpersonated = _a.isImpersonated, impersonatedUserId = _a.impersonatedUserId, impersonatedWorkspaceId = _a.impersonatedWorkspaceId, impersonatedWorkspaceName = _a.impersonatedWorkspaceName, stopImpersonation = _a.stopImpersonation;
    if (!isImpersonated)
        return null;
    return (_jsxs(Box, __assign({ sx: {
            backgroundColor: 'warning.500',
            color: 'warning.contrastText',
            p: 2,
            textAlign: 'center',
            position: 'relative'
        } }, { children: [_jsx(Typography, { children: impersonatedUserId
                    ? "You are impersonating user ID: ".concat(impersonatedUserId)
                    : "You are impersonating workspace: ".concat(impersonatedWorkspaceName || impersonatedWorkspaceId) }), _jsx(Button, __assign({ variant: "solid", onClick: stopImpersonation, sx: { mt: 1 } }, { children: "Stop Impersonation" }))] })));
};
